import Link from 'next/link';
import axios from 'axios';
import Modal from 'react-modal';

const Itembuy = (props)=>{
    const handlerInvoice = (id)=>{
        props.setShowModal(id);
    };
    let method = 'N/A';
    switch (props.data.modo_pago){
        case 'TD':
            method = 'Tarjeta de credito o debito';
            break;
        case 'PA':
            method = 'Paypal';
            break;
        case 'OX':
            method = 'OXXO';
            break;
        case 'SP':
            method = 'SPEI';
            break;
        case 'BB':
            method = 'Deposito BBVA';
            break;
        default:
            method = 'Medio de pago no identificado';
            break;
    }
    return  <div className="accountHistoryItem">
        <div className="accountHistoryItemColumn">
            <div className="accountHistoryItemTitle">
                Número de compra - {props.data.slug}
            </div>
            <div className="accountHistoryItemSecond">
                <Link href={`/cuenta/compra/${props.data.slug}`} >
                    <a target="_blank">Ver detalle</a>
                </Link>
            </div>
            <div className="accountHistoryItemSecond accountHistoryItemSecondAction"
                 onClick={()=>{ handlerInvoice(props.data.id_compra)}}
            >
                Solicita tu factura
            </div>
            <div className="accountHistoryItemSecond">Comprado {props.data.fecha_compra_human}, {props.data.fecha_compra}</div>
            <div className="accountHistoryItemSecond">Método de pago: {method}</div>
        </div>
        <div className="accountHistoryItemColumn">
            <span className="accountHistoryItemStatus">{props.data.statusText}</span>

        </div>
    </div>
};

export default Itembuy;
